import GuaranteeProviderService from '../services/guarantee-provider-service';
import RetrofitAccountService from '../services/retrofit-account-service';

export const guaranteeProvider = {
  namespaced: true,
  state: {
    guaranteeProvider: null,
    guaranteeProviders: [],
    guaranteeProviderCallLogs: [],
    retrofitAccount: null,
    retrofitAccountAppData: {},
    guaranteeProviderRequestsLogs: [],
  },
  actions: {
    getCallLogs({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return GuaranteeProviderService.getAllCallLogs(id).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setGuaranteeProviderCallLogs', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    registerGuaranteeProvider({ commit, dispatch }, data) {
      commit('setIsBusy', true, { root: true });
      return GuaranteeProviderService.register(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          setTimeout(() => {
            dispatch('executeLastSearch');
          }, 6000);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    getGuaranteeProvider({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      commit('setGuaranteeProvider', null);
      return GuaranteeProviderService.get(id).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setGuaranteeProvider', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    updateGuaranteeProvider({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return GuaranteeProviderService.update(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    deleteGuaranteeProvider({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });

      return GuaranteeProviderService.delete(payload.guaranteeProviderId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setGuaranteeProvider', null);
          const { message } = result;
          return Promise.resolve(message);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    getAllGuaranteeProviders({ commit }) {
      return GuaranteeProviderService.getAll().then(
        (result) => {
          commit('setGuaranteeProviders', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getRetrofitAccount({ commit }, retrofitAccountId) {
      commit('setIsBusy', true, { root: true });
      commit('setRetrofitAccount', null);
      return RetrofitAccountService.getById(retrofitAccountId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setRetrofitAccount', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    getAppData({ commit }) {
      commit('setIsBusy', true, { root: true });
      return RetrofitAccountService.appData().then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setRetrofitAccountAppData', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    addUser({ commit }, { retrofitAccountId, accountId, firstName, lastName, roles }) {
      commit('setIsBusy', true, { root: true });
      return RetrofitAccountService.user(retrofitAccountId, {
        accountId,
        firstName,
        lastName,
        roles,
      }).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setRetrofitAccount', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    removeUser({ commit }, { retrofitAccountId, accountId }) {
      commit('setIsBusy', true, { root: true });
      return RetrofitAccountService.removeUser(retrofitAccountId, accountId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setRetrofitAccount', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    createGuaranteeProviderApiKey(_, request) {
      return GuaranteeProviderService.createGuaranteeProviderApiKey(request).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getRequestsLogs({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return GuaranteeProviderService.getAllRequestsLogs(id).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setGuaranteeProviderRequestsLogs', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    setGuaranteeProvider(state, newGuaranteeProvider) {
      state.guaranteeProvider = newGuaranteeProvider;
    },
    setGuaranteeProviders(state, newGuaranteeProviders) {
      state.guaranteeProviders = newGuaranteeProviders;
    },
    setGuaranteeProviderCallLogs(state, newGuaranteeProviderCallLogs) {
      state.guaranteeProviderCallLogs = newGuaranteeProviderCallLogs;
    },
    setRetrofitAccount(state, retrofitAccount) {
      state.retrofitAccount = retrofitAccount;
    },
    setRetrofitAccountAppData(state, appData) {
      state.retrofitAccountAppData = appData;
    },
    setGuaranteeProviderRequestsLogs(state, newGuaranteeProviderRequestsLogs) {
      state.guaranteeProviderRequestsLogs = newGuaranteeProviderRequestsLogs;
    },
  },
};
